<ng-container *transloco="let gt; read: 'general'">
  <!-- DXP privacy policy -->
  @if ((isUkShfyInstance$ | async) || (isUkDfpInstance$ | async)) {
    <div data-test-id="privacy-policy-frame-is-dxp" class="is-dxp">
      <div data-test-id="privacy-policy-frame-dxp-background" class="background">
        <img
          data-test-id="privacy-policy-frame-dxp-background-image"
          src="/assets/dxp/img/background.png"
          alt=""
          srcset=""
        />
      </div>
      <div data-test-id="privacy-policy-frame-dxp-content" class="dxp-content">
        <div
          data-test-id="privacy-policy-frame-dialog-content"
          class="px-0 px-sm-4"
          mat-dialog-content
        >
          <app-managed-privacy-policy
            data-test-id="privacy-policy-frame-manged-privacy-policy"
          ></app-managed-privacy-policy>
        </div>
        <div
          data-test-id="privacy-policy-frame-actions"
          mat-dialog-actions
          class="flex-row-reverse justify-content-between"
        >
          <button
            data-test-id="privacy-policy-frame-close-btn"
            class="btn btn-primary"
            cdkFocusInitial
            mat-dialog-close
          >
            {{ gt('closeButton') }}
          </button>
        </div>
      </div>
    </div>
  }
  <!-- [end] DXP privacy policy -->

  @if (!(isUkShfyInstance$ | async) && !(isUkDfpInstance$ | async)) {
    <div data-test-id="privacy-policy-frame-pdf-viewer-wrapper">
      <div
        data-test-id="privacy-policy-frame-dialog-content"
        class="px-0 px-sm-4"
        mat-dialog-content
      >
        <app-managed-privacy-policy
          data-test-id="privacy-policy-frame-managed-privacy-policy"
        ></app-managed-privacy-policy>
      </div>
      <div
        data-test-id="privacy-policy-frame-dialog-actions"
        mat-dialog-actions
        class="flex-row-reverse justify-content-between"
      >
        <button
          data-test-id="privacy-policy-frame-dialog-close-btn"
          class="btn btn-primary"
          cdkFocusInitial
          mat-dialog-close
        >
          {{ gt('closeButton') }}
        </button>
      </div>
    </div>
  }
</ng-container>
